import React, { useEffect } from 'react';
import './Contact.css';

const Contact = () => {
    useEffect(() => {
        document.title = "Contact - Jeledi";
    }, []);
    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Merci pour votre message ! (Simulation)");
    };

    return (
        <div className="page contact-page">
            <div className="container contact-container">
                <div className="contact-header">
                    <h1>Contactez-nous</h1>
                    <p>Une question ? Une suggestion ? Écrivez-nous.</p>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Nom</label>
                        <input type="text" id="name" placeholder="Votre nom" required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" id="email" placeholder="votre@email.com" required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea id="message" rows="5" placeholder="Votre message..." required></textarea>
                    </div>

                    <button type="submit" className="btn btn-primary submit-btn">Envoyer</button>
                </form>

                <div className="contact-info">
                    <p>Ou directement par email : <a href="mailto:contact@jeledi.com">contact@jeledi.com</a></p>
                </div>
            </div>
        </div>
    );
};

export default Contact;
